import { useEffect } from 'react';
import { getFocusOnState } from '@components/MainStage/focusOn.store';
import { filtersSubject } from '@context/ProjectFilters/FiltersSubject';
import { skip } from 'rxjs';

const useClearFocusOnFilters = () => {
  useEffect(() => {
    const subscription = filtersSubject
      .pipe(skip(1))
      .subscribe(() => getFocusOnState().clear());

    return () => subscription.unsubscribe();
  }, []);
};

export default useClearFocusOnFilters;
